import { useState, useEffect, useRef } from "react";
import { format, addYears } from "date-fns";
import useApiRequest from "../../../../utils/hooks/useApiRequest";
import { GET_ATTRACTIONS_CALENDAR, GET_DAYS_AVAILABLE_BYNAME } from "../../../api/apiRoutes";

interface CalendarDayItem {
  date: string;
  available: number;
  closed: boolean;
  partialUnavailable: boolean;
  previous: boolean;
  unavailable: boolean;
}

export default function useAttractionsCalendar(facilityIds: string | null, name?: string) {
  const { get } = useApiRequest();
  const isMountedRef = useRef(true);
  const [unavailableDates, setUnavailableDates] = useState<Date[]>([]);

  useEffect(() => {
    if (!facilityIds || !isMountedRef.current) return;

    const fetchCalendar = async () => {
      const dateFrom = format(new Date(), "yyyy-MM-dd");
      const dateTo = format(addYears(new Date(), 1), "yyyy-MM-dd");

      const endpoint = name
        ? GET_DAYS_AVAILABLE_BYNAME(facilityIds, dateFrom, dateTo, name)
        : GET_ATTRACTIONS_CALENDAR(facilityIds, dateFrom, dateTo);

      const { result, isError } = await get(endpoint);

      if (!isMountedRef.current) return;
      if (!isError && Array.isArray(result)) {
        const unavailable = (result as CalendarDayItem[])
          .filter((item) => item.unavailable === true)
          .map((item) => new Date(item.date));
        setUnavailableDates(unavailable);
      } else {
        setUnavailableDates([]);
      }
    };

    fetchCalendar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [facilityIds, name]);

  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  return { unavailableDates };
}
